import { FaUtensils } from "react-icons/fa";
import FoodDetailThemeBase from "./FoodDetailThemeBase";

const GOLD = "#C9A44C";
const DARK = "#2B2620";

const theme = {
  pageStyle: { backgroundColor: "#FFFDF9" },
  headerClassName: "sticky top-0 z-20 border-b bg-white/95 backdrop-blur",
  headerStyle: { borderColor: "#EFE9DA" },
  headerInnerClassName: "mx-auto flex h-16 max-w-2xl items-center justify-between px-4",
  iconButtonClassName: "flex h-11 w-11 items-center justify-center rounded-xl text-xl hover:bg-gray-50",
  titleClassName: "font-serif font-black",
  titleStyle: { color: DARK },
  badgeClassName: "absolute -left-1 -top-1 rounded-full px-1.5 text-[10px] font-bold text-white",
  badgeStyle: { backgroundColor: GOLD },
  cardClassName: "overflow-hidden rounded-2xl border bg-white",
  cardStyle: { borderColor: "#EFE9DA" },
  PlaceholderIcon: FaUtensils,
  placeholderClassName: "flex aspect-[4/3] items-center justify-center text-6xl sm:aspect-[16/9]",
  placeholderStyle: { backgroundColor: "#F6F1E6", color: GOLD },
  itemTitleClassName: "font-serif text-2xl font-black",
  itemTitleStyle: { color: DARK },
  descriptionClassName: "mt-3 leading-7 text-gray-500",
  priceStyle: { color: GOLD },
  stepperClassName: "flex items-center rounded-full bg-white shadow",
  ctaClassName: "min-h-12 flex-1 rounded-full px-5 font-bold text-white shadow-lg",
  ctaStyle: { backgroundColor: DARK },
};

const LuxuryWhiteFoodDetailTheme = (props) => <FoodDetailThemeBase {...props} theme={theme} />;

export default LuxuryWhiteFoodDetailTheme;
